export class DOMHelper {
    constructor() {}

    //EVENTS
    static addHandler(selectorOrElement, eventName, callback) {
        if (!selectorOrElement) return;
        if (selectorOrElement.nodeName != undefined) {
            // if it's element
            selectorOrElement.addEventListener(eventName, callback);
        } else {
            let matches = document.querySelectorAll(selectorOrElement);

            for (let i = 0; i < matches.length; i++) {
                matches[i].addEventListener(eventName, callback);
            }
        }
    }

    /**
     * @param  {[string]} selector  [description]
     * @param  {[string]} eventName [description]
     */
    static triggerEvent(selectorOrElement, eventName) {
        if (!selectorOrElement) return;
        if (selectorOrElement.nodeName != undefined) {
            // if it's element
            selectorOrElement.dispatchEvent(new Event(eventName, { cancelable: true }));//cancelable so preventDefault works
        } else {
            DOMHelper.querySelectorAction(selectorOrElement, (item) => {
                item.dispatchEvent(new Event(eventName, { cancelable: true }));//cancelable so preventDefault works
            });
        }
    }

    //CLASSES
    static hasClass(element, className) {
        var className = " " + className + " ";
        return (" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(className) > -1;
    }

    static addClass(selectorOrElement, className) {
        if (!selectorOrElement) return;
        if (selectorOrElement.nodeName != undefined) {
            // if it's element
            selectorOrElement.classList.add(className);
        } else {
            let matches = document.querySelectorAll(selectorOrElement);

            for (let i = 0; i < matches.length; i++) {
                matches[i].classList.add(className);
            }
        }
    }

    static removeClass(selectorOrElement, className) {
        if (!selectorOrElement) return;
        if (selectorOrElement.nodeName != undefined) {
            // if it's element
            selectorOrElement.classList.remove(className);
        } else {
            let matches = document.querySelectorAll(selectorOrElement);

            for (let i = 0; i < matches.length; i++) {
                matches[i].classList.remove(className);
            }
        }
    }

    //GENERAL
    static setInnerHTML(selector, html) {
        DOMHelper.querySelectorAction(selector, (item) => {
            item.innerHTML = html;
        });
    }

    static setTextContent(selector, content) {
        DOMHelper.querySelectorAction(selector, (item) => {
            item.textContent = content;
        });
    }

    static setValue(selector, value) {
        DOMHelper.querySelectorAction(selector, (item) => {
            item.value = value;
        });
    }

    static setAttribute(selector, attribute, value) {
        DOMHelper.querySelectorAction(selector, (item) => {
            item[attribute] = value;
        });
    }

    static setData(selector, key, value) {
        DOMHelper.querySelectorAction(selector, (item) => {
            item.dataset[key] = value;
        });
    }

    //INPUT
    // Restricts input for the given textbox to the given inputFilter function.
    static setInputFilter(textbox, inputFilter, preFilter) {
        ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (
            event
        ) {
            textbox.addEventListener(event, function (event2) {
                if (preFilter) {
                    this.value = preFilter(this.value);
                }
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        });
    }

    //UTIL
    static addExternalStyleSheet(cssUrl) {
        document
            .querySelector("head")
            .insertAdjacentHTML("beforeend", `<link rel="stylesheet" type="text/css" href="` + cssUrl + `" />`);
    }

    static addExternalFonts() {
        // document
        //     .querySelector("head")
        //     .insertAdjacentElement("beforeend", `<link rel="preconnect" href="https://fonts.googleapis.com"></link>`);
        // document
        //     .querySelector("head")
        //     .insertAdjacentElement("beforeend", `<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>`);
        document
            .querySelector("head")
            .insertAdjacentHTML(
                "beforeend",
                `
                <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap" rel="stylesheet">
                `
                // <link href="https://fonts.googleapis.com/css?family=Open Sans" rel="stylesheet"></link>
            );
    }

    static addExternalJs(jsUrl) {
        document
            .querySelector("body")
            .insertAdjacentHTML("beforeend", `<script type="text/javascript" src="` + jsUrl + `" async defer />`);
    }

    static querySelectorAction(selector, callback) {
        let matches = document.querySelectorAll(selector);

        for (let i = 0; i < matches.length; i++) {
            callback(matches[i]);
        }
    }

    static exec_body_scripts(body_el) {
        // Finds and executes scripts in a newly added element's body.
        // Needed since innerHTML does not run scripts.
        //
        // Argument body_el is an element in the dom.

        function nodeName(elem, name) {
            return elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase();
        }

        function evalScript(elem) {
            var data = elem.text || elem.textContent || elem.innerHTML || "",
                head = document.getElementsByTagName("head")[0] || document.documentElement,
                script = document.createElement("script");

            script.type = "text/javascript";
            try {
                // doesn't work on ie...
                script.appendChild(document.createTextNode(data));
            } catch (e) {
                // IE has funky script nodes
                script.text = data;
            }

            head.insertBefore(script, head.firstChild);
            head.removeChild(script);
        }

        // main section of function
        var scripts = [],
            script,
            children_nodes = body_el.childNodes,
            child,
            i;

        for (i = 0; children_nodes[i]; i++) {
            child = children_nodes[i];
            if (nodeName(child, "script") && (!child.type || child.type.toLowerCase() === "text/javascript")) {
                scripts.push(child);
            }
        }

        for (i = 0; scripts[i]; i++) {
            script = scripts[i];
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            evalScript(scripts[i]);
        }
    }

    static isElementInViewport(selectorOrElement) {
        let element = selectorOrElement;
        if (element.nodeName == undefined) {
            element = document.querySelector(selectorOrElement);
        }

        if(!element) return;
        var rect = element.getBoundingClientRect();            
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
